<template lang="pug">

.gl
	transition(name='fade')
		Versus
	//- .gl-sd(v-show="isVersusReady")
	//- 	h3 {{ $t('Points difference') }}
	//- 	ScoreDev
	.gl-sd(v-show="isVersusReady")
		h3 {{ $t('Score evolution') }}
		PointsDiferenceChart
	
</template>

<style lang="sass">

.gl
	padding: 2rem 1rem
		bottom: 2rem
	display: grid
	grid-auto-flow: row
	grid-gap: 2.667rem

	&-sd
		display: grid
		grid-auto-flow: row
		justify-items: center
		grid-gap: 3rem
		
</style>
	
<script>

import Versus from "@/components/subcomponents/versus/Versus.vue"
// import ScoreDev from "@/components/subcomponents/score-dev/ScoreDev.vue"
import PointsDiferenceChart from '@/components/subcomponents/points-difference-chart/PointsDifferenceChart.vue'

export default {
	name: "Globals",
	computed: {
		isVersusReady() {
			return this.$store.state.general.isVersusReady
		}
	},
	mounted() {
		this.$parent.triggerGlobalRefresh()
		this.$parent.goTop()
	},
	components: {
		Versus,
		// ScoreDev,
		PointsDiferenceChart
	}
}

</script>